import './tool-bar.css';

import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { CardBar } from '../card-bar/card-bar';
import { useToolBar } from './use-tool-bar';

export const ToolBar = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 530px)' });
  const { ref, toolbar, tempMenu, tempMenuSizedUpRef, tempMenuCurrentRef } = useToolBar();

  return (
    <CardBar centered={true} position="bottom">
      <>
        <div ref={ref} className="toolbar" style={{ width: isMobile ? undefined : 'max-content' }}>
          {toolbar.map((menu) => {
            const { id, currentVariant, variants, hook } = menu;
            const { fullHeight, Element } = variants[currentVariant];

            return (
              <div key={id} className="menu" style={{ alignSelf: fullHeight ? 'stretch' : 'center' }}>
                <Element hook={hook} />
              </div>
            );
          })}
        </div>
        {tempMenu && (
          <>
            <div ref={tempMenuSizedUpRef} className="size-up-menu">
              {tempMenu.variants[tempMenu.currentVariant + 1]?.Element({ hook: tempMenu.tempHook })}
            </div>
            <div ref={tempMenuCurrentRef} className="size-up-menu">
              {tempMenu.variants[tempMenu.currentVariant]?.Element({ hook: tempMenu.tempHook })}
            </div>
          </>
        )}
      </>
    </CardBar>
  );
};
